export const color = {
  brand: {
    primary: {
      '500': 'rgb(10, 186, 181)',
    }
  },
  return: {
    up: 'rgb(42, 186, 119)',
    down: 'rgb(242, 54, 69)',
  },
  sector: {
    red: 'rgb(242, 54, 69)',
  }
};



// WEBPACK FOOTER //
// ./src/legacy-tv-dls/index.js